import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { registerPwa } from "@/lib/pwa";
import { attachGlobalWaClickTracker } from "@/lib/adsTracking";

// Registra service worker + captura evento beforeinstallprompt (Android).
// Idempotente — safe pra hot reload.
registerPwa();

// Google Ads: escuta cliques em qualquer link wa.me / api.whatsapp.com em
// toda a app e dispara a conversão `wa_click`. Idempotente.
attachGlobalWaClickTracker();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
